const { defineMessages } = require('@sm/intl');

const COPY = defineMessages({
  AVAILABLE: {
    id: 'Pricing.Details.Available',
    defaultMessage: 'available',
    desc: '[Type: label][Vis: high] - Pricing details comparison feature cell value',
  },
  UNAVAILABLE: {
    id: 'Pricing.Details.Unavailable',
    defaultMessage: 'unavailable',
    desc: '[Type: label][Vis: high] - Pricing details comparison feature cell value',
  },
  BUSINESS_PLANS_LINK: {
    id: 'Pricing.Details.BusinessPlansLink',
    defaultMessage: 'Included with business plans',
    desc: '[Type: link][Vis: high] - Link to pricing teams details page',
  },
});

export default COPY;
